import { Statistic } from 'antd';
import styled from 'styled-components';
export const StyledStatistic = styled(Statistic)`
  .ant-statistic-content {
    font-weight: 500;
    color: #252631;
  }
  .ant-statistic-title {
    font-size: 1rem;
    padding-bottom: 0.1rem;
    color: #666666;
  }
`;